import * as React from 'react';
import {useE4ImpactProjectsContext} from '../../context';
import {ChartsContainer} from '../../Common/ChartsContainer';
import {configSchema} from './configSchema';

export function Output() {
    const {uoas, fields, baselineSubmissions, finalSubmissions, projectsBreakdown} = useE4ImpactProjectsContext();

    return <ChartsContainer
        configSchema={configSchema({
            baselineSubmissions,
            finalSubmissions,
            projectsBreakdown,
            fields,
            uoas
        })}
    />
}
